import React from 'react';

const galleryImages = [
  { src: 'https://images.unsplash.com/photo-1502602898657-3e91760cbb34?w=400&h=200&fit=crop', alt: 'Paris Eiffel Tower' },
  { src: 'https://images.unsplash.com/photo-1552832230-c0197dd311b5?w=400&h=200&fit=crop', alt: 'Rome Colosseum' },
  { src: 'https://images.unsplash.com/photo-1493976040374-85c8e12f0c0e?w=400&h=200&fit=crop', alt: 'Japan Temple' },
  { src: 'https://images.unsplash.com/photo-1518684079-3c830dcef090?w=400&h=200&fit=crop', alt: 'Dubai Skyline' },
  { src: 'https://images.unsplash.com/photo-1506973035872-a4ec16b8e8d9?w=400&h=200&fit=crop', alt: 'Sydney Opera' },
  { src: 'https://images.unsplash.com/photo-1513407030348-c983a97b98d8?w=400&h=200&fit=crop', alt: 'Northern Lights' },
  { src: 'https://images.unsplash.com/photo-1524413840807-0c3cb6fa808d?w=400&h=200&fit=crop', alt: 'Santorini Greece' },
  { src: 'https://images.unsplash.com/photo-1525625293386-3f8f99389edd?w=400&h=200&fit=crop', alt: 'Bali Indonesia' },
  { src: 'https://images.unsplash.com/photo-1552505557-c085030eea99?w=400&h=200&fit=crop', alt: 'New York Skyline' },
  { src: 'https://images.unsplash.com/photo-1526711657229-e7e080ed7aa1?w=400&h=200&fit=crop', alt: 'Great Wall China' },
  { src: 'https://images.unsplash.com/photo-1548013146-72479768bada?w=400&h=200&fit=crop', alt: 'Taj Mahal India' },
  { src: 'https://images.unsplash.com/photo-1516483638261-f4dbaf036963?w=400&h=200&fit=crop', alt: 'Amalfi Coast Italy' },
  { src: 'https://images.unsplash.com/photo-1528181304800-259b08848526?w=400&h=200&fit=crop', alt: 'Bangkok Thailand' },
  { src: 'https://images.unsplash.com/photo-1537996194471-e657df975ab4?w=400&h=200&fit=crop', alt: 'Bali Rice Terraces' },
  { src: 'https://images.unsplash.com/photo-1539037116277-4db20889f2d4?w=400&h=200&fit=crop', alt: 'London Big Ben' },
  { src: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=400&h=200&fit=crop', alt: 'Maldives Beach' },
  { src: 'https://images.unsplash.com/photo-1490806843957-31f4c9a91c65?w=400&h=200&fit=crop', alt: 'Mount Fuji Japan' },
  { src: 'https://images.unsplash.com/photo-1500916434205-0c77489c6cf7?w=400&h=200&fit=crop', alt: 'Times Square NYC' },
  { src: 'https://images.unsplash.com/photo-1533105079780-92b9be482077?w=400&h=200&fit=crop', alt: 'Santorini Sunset' },
  { src: 'https://images.unsplash.com/photo-1549144511-f099e773c147?w=400&h=200&fit=crop', alt: 'Paris Arc de Triomphe' },
  { src: 'https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?w=400&h=200&fit=crop', alt: 'Swiss Alps Lake' },
  { src: 'https://images.unsplash.com/photo-1518509562904-e7ef99cdcc86?w=400&h=200&fit=crop', alt: 'Christ Redeemer Rio' },
  { src: 'https://images.unsplash.com/photo-1526392060635-9d6019884377?w=400&h=200&fit=crop', alt: 'Machu Picchu Peru' },
  { src: 'https://images.unsplash.com/photo-1530841377377-3ff06c0ca713?w=400&h=200&fit=crop', alt: 'Pyramids Egypt' },
  { src: 'https://images.unsplash.com/photo-1541417904950-b855846fe074?w=400&h=200&fit=crop', alt: 'Petra Jordan' },
  { src: 'https://images.unsplash.com/photo-1512100356356-de1b84283e18?w=400&h=200&fit=crop', alt: 'Tropical Overwater' },
  { src: 'https://images.unsplash.com/photo-1501785888041-af3ef285b470?w=400&h=200&fit=crop', alt: 'Mountain Lake Scenery' },
  { src: 'https://images.unsplash.com/photo-1520483601560-389dff434fdf?w=400&h=200&fit=crop', alt: 'Venice Canals' },
  { src: 'https://images.unsplash.com/photo-1543731068-7e0f5beff43a?w=400&h=200&fit=crop', alt: 'Singapore Marina Bay' },
  { src: 'https://images.unsplash.com/photo-1596422846543-75c6fc197f07?w=400&h=200&fit=crop', alt: 'Barcelona Sagrada' },
];

// Duplicate for seamless loop
const allImages = [...galleryImages, ...galleryImages];

const LandmarkGallery = () => {
  return (
    <div className="w-full overflow-hidden" style={{ height: 120 }} data-testid="landmark-gallery">
      <div className="gallery-track flex" style={{ width: `${allImages.length * 200}px` }}>
        {allImages.map((img, i) => (
          <div
            key={`${img.alt}-${i}`}
            className="flex-shrink-0"
            style={{ width: 200, height: 120 }}
          >
            <img
              src={img.src}
              alt={img.alt}
              loading={i < 10 ? 'eager' : 'lazy'}
              className="w-full h-full object-cover"
            />
          </div>
        ))}
      </div>
      <style>{`
        .gallery-track {
          animation: galleryScroll ${galleryImages.length * 3}s linear infinite;
        }
        @keyframes galleryScroll {
          from { transform: translateX(0); }
          to { transform: translateX(-${galleryImages.length * 200}px); }
        }
      `}</style>
    </div>
  );
};

export default LandmarkGallery;
